// import React, { useState, useRef, useEffect, useCallback } from "react";
// import { useRecording } from "../../context/RecordingContext";
// import StopConfirmModal from "./StopConfirmModal";
// import ReactiveWaves from "../../streaming/reactivewaves";

// const FloatingRecorder = () => {
//   const {
//     isGlobalRecording,
//     isGlobalPaused,
//     globalElapsedTime,
//     patientInfo,
//     showFloatingPopup,
//     isOnRecordingPage,
//     audioStreamRef,
//     togglePause,
//     onSave,
//     onDelete,
//     stopTimer,
//   } = useRecording();

//   const [position, setPosition] = useState({ x: window.innerWidth - 380, y: 100 });
//   const [isDragging, setIsDragging] = useState(false);
//   const [showStopModal, setShowStopModal] = useState(false);
//   const dragOffset = useRef({ x: 0, y: 0 });
//   const popupRef = useRef(null);

//   // Dragging logic
//   const handleMouseDown = useCallback((e) => {
//     if (e.target.closest(".popup-control-btn")) return;
//     setIsDragging(true);
//     dragOffset.current = {
//       x: e.clientX - position.x,
//       y: e.clientY - position.y,
//     };
//     e.preventDefault();
//   }, [position]);

//   const handleMouseMove = useCallback((e) => {
//     if (!isDragging) return;
//     const newX = Math.max(0, Math.min(window.innerWidth - 360, e.clientX - dragOffset.current.x));
//     const newY = Math.max(0, Math.min(window.innerHeight - 100, e.clientY - dragOffset.current.y));
//     setPosition({ x: newX, y: newY });
//   }, [isDragging]);

//   const handleMouseUp = useCallback(() => {
//     setIsDragging(false);
//   }, []);

//   // Touch support
//   const handleTouchStart = useCallback((e) => {
//     if (e.target.closest(".popup-control-btn")) return;
//     const touch = e.touches[0];
//     setIsDragging(true);
//     dragOffset.current = {
//       x: touch.clientX - position.x,
//       y: touch.clientY - position.y,
//     };
//   }, [position]);

//   const handleTouchMove = useCallback((e) => {
//     if (!isDragging) return;
//     const touch = e.touches[0];
//     const newX = Math.max(0, Math.min(window.innerWidth - 360, touch.clientX - dragOffset.current.x));
//     const newY = Math.max(0, Math.min(window.innerHeight - 100, touch.clientY - dragOffset.current.y));
//     setPosition({ x: newX, y: newY });
//   }, [isDragging]);

//   useEffect(() => {
//     if (isDragging) {
//       window.addEventListener("mousemove", handleMouseMove);
//       window.addEventListener("mouseup", handleMouseUp);
//       window.addEventListener("touchmove", handleTouchMove);
//       window.addEventListener("touchend", handleMouseUp);
//     }
//     return () => {
//       window.removeEventListener("mousemove", handleMouseMove);
//       window.removeEventListener("mouseup", handleMouseUp);
//       window.removeEventListener("touchmove", handleTouchMove);
//       window.removeEventListener("touchend", handleMouseUp);
//     };
//   }, [isDragging, handleMouseMove, handleMouseUp, handleTouchMove]);

//   const formatTime = (seconds) => {
//     const mins = Math.floor(seconds / 60);
//     const secs = seconds % 60;
//     return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
//   };

//   const handleTogglePause = () => {
//     togglePause();
//   };

//   const handleStop = () => {
//     // Pause first before showing modal
//     if (!isGlobalPaused) {
//       stopTimer();
//       togglePause();
//     }
//     setShowStopModal(true);
//   };

//   const handleSave = () => {
//     setShowStopModal(false);
//     onSave();
//   };

//   const handleDeleteRecording = () => {
//     setShowStopModal(false);
//     onDelete();
//   };

//   const handleCloseStopModal = () => {
//     setShowStopModal(false);
//     // Resume recording if was paused by stop button
//     if (isGlobalPaused) {
//       togglePause();
//     }
//   };

//   // Don't show if not recording, or if user is on the recording page
//   if (!isGlobalRecording || !showFloatingPopup || isOnRecordingPage) {
//     return null;
//   }

//   return (
//     <>
//       <div
//         ref={popupRef}
//         className="fixed z-[10000] select-none"
//         style={{
//           left: `${position.x}px`,
//           top: `${position.y}px`,
//           cursor: isDragging ? "grabbing" : "grab",
//         }}
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//       >
//         {/* Main Floating Popup */}
//         <div
//           className="bg-white rounded-2xl shadow-[0px_8px_32px_rgba(0,0,0,0.15)] border border-gray-100 overflow-hidden"
//           style={{ width: "340px" }}
//         >
//           {/* Header - Drag handle */}
//           <div className="bg-gradient-to-r from-[#1D2951] to-[#2a3d6b] px-4 py-2.5 flex items-center justify-between">
//             <div className="flex items-center gap-2">
//               <div className="relative flex items-center justify-center">
//                 <span
//                   className={`w-2.5 h-2.5 rounded-full ${
//                     isGlobalPaused ? "bg-yellow-400" : "bg-red-500"
//                   }`}
//                 />
//                 {!isGlobalPaused && (
//                   <span className="absolute w-2.5 h-2.5 rounded-full bg-red-500 animate-ping" />
//                 )}
//               </div>
//               <span className="text-white text-sm font-medium">
//                 {isGlobalPaused ? "Paused" : "Recording"}
//               </span>
//             </div>
//             <div className="flex items-center gap-2">
//               <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="opacity-50">
//                 <circle cx="4" cy="4" r="1.5" fill="white" />
//                 <circle cx="4" cy="8" r="1.5" fill="white" />
//                 <circle cx="4" cy="12" r="1.5" fill="white" />
//                 <circle cx="12" cy="4" r="1.5" fill="white" />
//                 <circle cx="12" cy="8" r="1.5" fill="white" />
//                 <circle cx="12" cy="12" r="1.5" fill="white" />
//               </svg>
//             </div>
//           </div>

//           {/* Body */}
//           <div className="px-4 py-3">
//             {/* Patient Info */}
//             {patientInfo && (
//               <div className="flex items-center gap-3 mb-3">
//                 <div className="w-9 h-9 rounded-full bg-[#E17954] flex items-center justify-center text-white text-sm font-bold flex-shrink-0">
//                   {patientInfo.firstname?.charAt(0)?.toUpperCase() || "P"}
//                   {patientInfo.lastname?.charAt(0)?.toUpperCase() || ""}
//                 </div>
//                 <div className="flex-1 min-w-0">
//                   <div className="text-sm font-semibold text-[#1D2951] truncate">
//                     {patientInfo.firstname} {patientInfo.lastname}
//                   </div>
//                   <div className="text-xs text-[#7E7E7E]">
//                     #{patientInfo.patientid}
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Waveform & Timer */}
//             <div className="flex items-center justify-between bg-[#F9FAFB] rounded-xl px-3 py-2.5 mb-3">
//               <div className="h-5 flex-1 overflow-hidden mr-3">
//                 <ReactiveWaves
//                   isPaused={!isGlobalPaused}
//                   mediaStream={audioStreamRef.current}
//                 />
//               </div>
//               <div
//                 className="text-[#1D2951] font-semibold text-base tabular-nums"
//                 style={{ fontFamily: "Inter, monospace" }}
//               >
//                 {formatTime(globalElapsedTime)}
//               </div>
//             </div>

//             {/* Controls */}
//             <div className="flex items-center justify-center gap-4">
//               {/* Pause/Play */}
//               <button
//                 className="popup-control-btn w-11 h-11 rounded-full bg-[#F3F4F6] hover:bg-[#E5E7EB] flex items-center justify-center transition-colors"
//                 onClick={handleTogglePause}
//                 title={isGlobalPaused ? "Resume" : "Pause"}
//               >
//                 {isGlobalPaused ? (
//                   <svg width="18" height="18" viewBox="0 0 24 24" fill="#1D2951">
//                     <path d="M8 5v14l11-7z" />
//                   </svg>
//                 ) : (
//                   <svg width="18" height="18" viewBox="0 0 24 24" fill="#1D2951">
//                     <rect x="6" y="4" width="4" height="16" rx="1" />
//                     <rect x="14" y="4" width="4" height="16" rx="1" />
//                   </svg>
//                 )}
//               </button>

//               {/* Stop */}
//               <button
//                 className="popup-control-btn w-12 h-12 rounded-full bg-[#EF4444] hover:bg-[#DC2626] flex items-center justify-center transition-colors shadow-lg shadow-red-200"
//                 onClick={handleStop}
//                 title="Stop"
//               >
//                 <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
//                   <rect x="6" y="6" width="12" height="12" rx="2" />
//                 </svg>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Stop Confirmation Modal - matches ExitModal / DeleteConfirmation UI */}
//       <StopConfirmModal
//         isOpen={showStopModal}
//         onSave={handleSave}
//         onDelete={handleDeleteRecording}
//         onClose={handleCloseStopModal}
//       />
//     </>
//   );
// };

// export default FloatingRecorder;

import React, { useState, useRef, useEffect, useCallback } from "react";
import { useRecording } from "../../context/RecordingContext";
import StopConfirmModal from "./StopConfirmModal";
import ReactiveWaves from "../../streaming/reactivewaves";
import { Chevron, dargIcon, pauseIcon, playIcon } from "./svg";

const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
const POPUP_WIDTH = 360;

const formatTime = (seconds) => {
  const s = Math.max(0, Number(seconds) || 0);
  const mins = Math.floor(s / 60);
  const secs = s % 60;
  return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
};

const FloatingRecorder = () => {
  const {
    isGlobalRecording,
    isGlobalPaused,
    globalElapsedTime,
    patientInfo,
    showFloatingPopup,
    isOnRecordingPage,
    audioStreamRef,
    togglePause,
    onSave,
    onDelete,
    stopTimer,
  } = useRecording();

  // start near top-right
  const [position, setPosition] = useState(() => ({
    x: Math.max(16, (window.innerWidth - POPUP_WIDTH) / 2),
    y: 7,
  }));

  const [isDragging, setIsDragging] = useState(false);
  const [showStopModal, setShowStopModal] = useState(false);
  const [isMinimized, setIsMinimized] = useState(true);

  const dragOffset = useRef({ x: 0, y: 0 });

  // IMPORTANT: only drag if user isn't clicking control buttons
  const handleMouseDown = useCallback(
    (e) => {
      if (e.target.closest(".popup-control-btn")) return;
      setIsDragging(true);
      dragOffset.current = {
        x: e.clientX - position.x,
        y: e.clientY - position.y,
      };
      e.preventDefault();
    },
    [position],
  );

  const handleMouseMove = useCallback(
    (e) => {
      if (!isDragging) return;

      // width depends on state
      const w = isMinimized ? 360 : 420;
      const h = isMinimized ? 56 : 160;

      const newX = clamp(
        e.clientX - dragOffset.current.x,
        8,
        window.innerWidth - w - 8,
      );
      const newY = clamp(
        e.clientY - dragOffset.current.y,
        8,
        window.innerHeight - h - 8,
      );

      setPosition({ x: newX, y: newY });
    },
    [isDragging, isMinimized],
  );

  const handleMouseUp = useCallback(() => setIsDragging(false), []);

  // touch
  const handleTouchStart = useCallback(
    (e) => {
      if (e.target.closest(".popup-control-btn")) return;
      const t = e.touches[0];
      setIsDragging(true);
      dragOffset.current = {
        x: t.clientX - position.x,
        y: t.clientY - position.y,
      };
    },
    [position],
  );

  const handleTouchMove = useCallback(
    (e) => {
      if (!isDragging) return;
      const t = e.touches[0];

      const w = isMinimized ? 360 : 420;
      const h = isMinimized ? 56 : 160;

      const newX = clamp(
        t.clientX - dragOffset.current.x,
        8,
        window.innerWidth - w - 8,
      );
      const newY = clamp(
        t.clientY - dragOffset.current.y,
        8,
        window.innerHeight - h - 8,
      );

      setPosition({ x: newX, y: newY });
    },
    [isDragging, isMinimized],
  );

  useEffect(() => {
    if (!isDragging) return;

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("touchmove", handleTouchMove, { passive: false });
    window.addEventListener("touchend", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleMouseUp);
    };
  }, [isDragging, handleMouseMove, handleMouseUp, handleTouchMove]);

  const handleTogglePause = () => togglePause();

  const handleStop = () => {
    // Pause first before modal (your logic)
    if (!isGlobalPaused) {
      stopTimer();
      togglePause();
    }
    setShowStopModal(true);
  };

  const handleSave = () => {
    setShowStopModal(false);
    onSave();
  };

  const handleDeleteRecording = () => {
    setShowStopModal(false);
    onDelete();
  };

  const handleCloseStopModal = () => {
    setShowStopModal(false);
    // resume if stop button paused it
    if (isGlobalPaused) togglePause();
  };

  const [imgError, setImgError] = useState(false);

  const initials = (() => {
    const f = patientInfo?.firstname?.charAt(0)?.toUpperCase() || "J";
    const l = patientInfo?.lastname?.charAt(0)?.toUpperCase() || "D";
    return `${f}${l}`;
  })();

  const profileImgUrl = patientInfo?.patientid
    ? `/cloud-assets/chim/public/assets/images/profilepictures/${patientInfo.patientid}.png`
    : null;

  // Reset image error state when patient changes
  useEffect(() => {
    setImgError(false);
  }, [patientInfo?.patientid]);

  // Don't show if not recording, or if user is on the recording page
  if (!isGlobalRecording || !showFloatingPopup || isOnRecordingPage)
    return null;

  return (
    <>
      <div
        className="fixed z-[10000] select-none"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          cursor: isDragging ? "grabbing" : "grab",
        }}
        onMouseDown={handleMouseDown}
        onTouchStart={handleTouchStart}
      >
        {/* COLLAPSED (red pill bar) */}
        {isMinimized ? (
          <div className="w-[360px] h-[52px] rounded-2xl bg-[#E11D2E] shadow-[0px_18px_40px_rgba(0,0,0,0.20)] flex items-center px-3">
            <div className="flex items-center gap-2">
              {dargIcon}
              <span className="w-2 h-2 rounded-full bg-white/95" />
            </div>

            <div className="flex-1 text-center text-white font-medium text-sm">
              Recording...
            </div>

            <div className="flex items-center gap-3">
              <div className="text-white font-semibold tabular-nums text-sm">
                {formatTime(globalElapsedTime)}
              </div>
              <button
                className="popup-control-btn p-1.5 rounded-lg hover:bg-white/10 transition"
                onClick={() => setIsMinimized(false)}
                title="Expand"
              >
                <Chevron up />
              </button>
            </div>
          </div>
        ) : (
          /* EXPANDED (navy card + red bottom bar) */
          <div className="w-[360px] rounded-2xl overflow-hidden shadow-[0px_22px_60px_rgba(0,0,0,0.25)]">
            {/* Navy Card */}
            <div className="bg-[#15244A] px-3 pt-3 pb-3">
              {/* top row: avatar + name */}
              <div className="flex items-center gap-3 mb-3">
                {profileImgUrl && !imgError ? (
                  <img
                    src={profileImgUrl}
                    alt={initials}
                    className="w-11 h-11 rounded-full object-cover flex-shrink-0"
                    onError={() => setImgError(true)}
                  />
                ) : (
                  <div className="w-11 h-11 rounded-full bg-[#2C7A7B] flex items-center justify-center text-white font-semibold flex-shrink-0">
                    {initials}
                  </div>
                )}

                <div className="min-w-0 text-start">
                  <div className="text-white font-normal text-sm truncate">
                    {patientInfo?.firstname} {patientInfo?.lastname}
                  </div>
                  <div className="text-[#FFFFFF80] text-xs">
                    {isGlobalPaused
                      ? "Recording paused"
                      : "Visit recording in progress"}
                  </div>
                </div>
              </div>

              {/* controls row */}
              <div className="flex items-center gap-4">
                {/* pause/resume */}
                <button
                  className="popup-control-btn w-11 h-11 rounded-full bg-[#EF4444] border-[1px] border-[#fff] hover:brightness-95 active:scale-[0.98] transition flex items-center justify-center shadow-[0px_8px_20px_rgba(239,68,68,0.35)]"
                  onClick={handleTogglePause}
                  title={isGlobalPaused ? "Resume" : "Pause"}
                >
                  {isGlobalPaused ? playIcon : pauseIcon}
                </button>

                {/* waveform */}
                <div className="flex-1 h-10 flex items-center overflow-hidden">
                  <ReactiveWaves
                    // your component naming is confusing; keep your prop contract
                    isPaused={!isGlobalPaused}
                    mediaStream={audioStreamRef.current}
                  />
                </div>

                {/* timer */}
                <div className="flex items-center gap-2 text-white">
                  <span className="w-2 h-2 rounded-full bg-[#EF4444]" />
                  <span className="font-semibold tabular-nums text-xs">
                    {formatTime(globalElapsedTime)}
                  </span>
                </div>

                {/* stop */}
                <button
                  className="popup-control-btn w-11 h-11 rounded-full bg-[#EF4444] hover:bg-[#DC2626] border-[1px] border-[#fff] active:scale-[0.98] transition flex items-center justify-center"
                  onClick={handleStop}
                  title="Stop"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
                    <rect x="7" y="7" width="10" height="10" rx="2" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Red Bottom Bar */}
            <div className="bg-[#E11D2E] h-[52px] flex items-center px-3">
              <div className="flex items-center gap-2">
                {dargIcon}
                <span className="w-3 h-3 rounded-full bg-white/95" />
              </div>

              <div className="flex-1 text-center text-white font-medium text-sm font-inter">
                Recording...
              </div>

              <div className="flex items-center gap-3">
                <div className="text-white font-semibold tabular-nums text-sm font-inter">
                  {formatTime(globalElapsedTime)}
                </div>
                <button
                  className="popup-control-btn p-1.5 rounded-lg hover:bg-white/10 transition"
                  onClick={() => setIsMinimized(true)}
                  title="Minimize"
                >
                  <Chevron up={false} />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <StopConfirmModal
        isOpen={showStopModal}
        onSave={handleSave}
        onDelete={handleDeleteRecording}
        onClose={handleCloseStopModal}
      />
    </>
  );
};

export default FloatingRecorder;
